import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";
import PrimaryButton from "../common/PrimaryButton";
import { logout, startPortalOnboarding } from "../../setup/auth/oidc";

/**
 * Shown by the gate to a signed-in user who has no organization (a customer who came through
 * single sign-on). "Continue" starts the Waffy ID onboarding page (portal login + organization);
 * "No" saves nothing: the user stays signed in and can go back to the Waffy app or sign out.
 */
const PortalOnboardingPrompt: React.FC = () => {
  const { t } = useTranslation();
  const userAppUrl = process.env.REACT_APP_URL?.trim();

  return (
    <div className={styles.card}>
      <div>
        <h2 className={styles.title}>{t("lbl_portal_onboarding_title")}</h2>
        <p className={styles.subtitle}>{t("lbl_portal_onboarding_body")}</p>
      </div>
      <div className={styles.submitRow}>
        <PrimaryButton type="button" onClick={() => startPortalOnboarding()}>
          {t("lbl_portal_onboarding_continue")}
        </PrimaryButton>
      </div>
      <div className={styles.onboardingLinks}>
        {userAppUrl && (
          <a href={userAppUrl}>{t("lbl_portal_onboarding_go_to_app")}</a>
        )}
        <button type="button" onClick={() => logout()}>
          {t("lbl_portal_onboarding_sign_out")}
        </button>
      </div>
    </div>
  );
};

export default PortalOnboardingPrompt;
